import { Component, Inject } from '@angular/core';
import { ConfirmModalSettings } from '@api-ui-app/src/app/shared/lib/confirm-modal-settings';
import { DialogRef } from '../dialog/dialog-ref';
import { DIALOG_DATA } from '../dialog/dialog-tokens';
import { DialogSize } from '@gelato-api-ui/sdk/src/lib/shared/dialog/types/dialog-size';
import { DialogContainerComponent } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-container.component';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'gd-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [DialogContainerComponent, NgIf, TranslateModule],
})
export class ConfirmDialogComponent {
  size = DialogSize.Small;

  constructor(
    private readonly dialogRef: DialogRef,
    @Inject(DIALOG_DATA) private readonly dialogData: ConfirmModalSettings,
  ) {}

  get title(): string {
    return this.dialogData?.title;
  }

  get titleIconUrl(): string {
    return this.dialogData?.titleIconUrl;
  }

  get titleStyle(): string {
    return this.dialogData?.titleStyle;
  }

  get body(): string {
    return this.dialogData?.body;
  }

  get approveButtonText(): string {
    return this.dialogData?.approveButtonText;
  }

  get approveButtonIconUrl(): string {
    return this.dialogData?.approveButtonIconUrl;
  }

  get approveButtonStyle(): string {
    return this.dialogData?.approveButtonStyle || 'primary';
  }

  get denyButtonText(): string {
    return this.dialogData?.denyButtonText;
  }

  get denyButtonIconUrl(): string {
    return this.dialogData?.denyButtonIconUrl;
  }

  get denyButtonStyle(): string {
    return this.dialogData?.denyButtonStyle || 'secondary';
  }

  get hideApplyButton(): boolean {
    return this.dialogData?.hideApplyButton;
  }

  get hideDenyButton(): boolean {
    return this.dialogData?.hideDenyButton;
  }

  onApproveButtonClick(): void {
    this.dialogRef.close(true);
  }

  onDenyButtonClick(): void {
    this.dialogRef.close(undefined);
  }
}
